import { memo } from "react";
import { FaChevronUp } from "react-icons/fa";

// This button moves the scroll bar to the top of the page
const JumperButton = ({ buttonColor }) => {
  return (
    <>
      <a id="jumper-button" href="#body" title="Jump to Top of the Page!" className={`border border-2 border-${buttonColor}`}>
        <FaChevronUp className={"text-" + buttonColor} />
      </a>
    </>
  );
};

export default memo(JumperButton);
